<template>
  <b-container fluid>
    <b-row>
      <b-col>
        <h3>
          <b-badge variant="primary">
            User List
          </b-badge>
          <b-spinner small v-if="waiting" class="align-middle"></b-spinner>
        </h3>
      </b-col>
      <b-col sm="6" class="pb-2 pb-sm-0">
        <b-button
          block
          @click="$router.go(-1)">
          Back
        </b-button>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <strong>Existing Users</strong>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-table
          small
          responsive
          striped
          stacked="sm"
          :busy="waiting"
          :items="items"
          :fields="fields">
          <div slot="table-busy" class="text-center text-danger">
            <b-spinner class="align-middle"></b-spinner>
            <!-- <strong>Loading...</strong> -->
          </div>
        </b-table>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { authService } from '../_services';
export default {
  data() {
    return {
      waiting: false,
      items: [],
      fields: [
        {
          key: 'UserID',
          label: 'User ID'
        },
        {
          key: 'Username',
          label: 'Name'
        },
        {
          key: 'Role',
          label: 'User Group'
        },
      ]
    }
  },
  created() {
    let vm = this
    this.waiting = true
    authService.getUsers()
    .then((resp)=> {
      vm.items = resp.data
      this.waiting = false
    })
  }
}
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/components/UserListPage.vue